export enum DocumentationLevel {
    Established = 1,
    Probable = 2,
    Suspected = 3,
    Possible = 4,
    DoubtfulUnknown = 5,
}
